import { Send } from '@tamagui/lucide-icons-2'
import { useEffect, useRef, useState } from 'react'
import Button from 'components/button'
import { Input, XStack } from 'tamagui'
import { useAiHelp } from './AiHelpProvider'
import { useAiHelpSend } from './useAiHelpSend'

interface AiHelpInputProps {
    autoFocus?: boolean
}

export default function AiHelpInput({ autoFocus }: AiHelpInputProps) {
    const [input, setInput] = useState('')
    const { isLoading } = useAiHelp()
    const send = useAiHelpSend()
    const inputRef = useRef<HTMLInputElement>(null)

    useEffect(() => {
        if (autoFocus) {
            // Small delay to ensure the element is mounted and visible
            const timer = setTimeout(() => inputRef.current?.focus(), 50)
            return () => clearTimeout(timer)
        }
    }, [autoFocus])

    const handleSend = () => {
        if (!input.trim() || isLoading) return
        send(input)
        setInput('')
    }

    return (
        <XStack gap="$2" padding="$3" borderTopWidth={1} borderTopColor="$borderColor">
            <Input
                ref={inputRef as any}
                flex={1}
                placeholder="Ask about Buyerflo..."
                value={input}
                onChangeText={setInput}
                onKeyDown={(e: any) => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault()
                        handleSend()
                    }
                }}
                disabled={isLoading}
            />
            <Button
                size="$3"
                circular
                backgroundColor="$primary"
                hoverStyle={{ backgroundColor: '$green11' }}
                pressStyle={{ backgroundColor: '$green12' }}
                onPress={handleSend}
                disabled={isLoading || !input.trim()}
                opacity={isLoading || !input.trim() ? 0.5 : 1}
            >
                <Send size={16} color="white" />
            </Button>
        </XStack>
    )
}
